<div class="pme-sticky-footer-wrapper">
  <pme-header></pme-header>

  <div class="pme-sticky-footer-content">
    <main>
      <div class="pme-container">
        <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-start-center display-utils-gap-0 display-utils-gt-sm-gap-30">
          <div class="pme-col display-utils-flex-100 display-utils-gt-sm-flex-50">
            <div class="pme-squircles-wrapper">
              <div class="pme-squircles-text">
                <div class="pme-squircles-oops">Oops!</div>
                <div>Você está acessando uma página inexistente ou fora do ar!</div>
              </div>
              <img class="pme-squircles" src="assets/images/squircles.svg">
            </div>
          </div>

          <div class="pme-col display-utils-flex-100 display-utils-gt-sm-flex-50">
            <div class="pme-page-not-found-message">
              Estamos trabalhando para resolver este problema.<br>
              Por favor, tente novamente.
            </div>
            <a href="https://empresas.serasaexperian.com.br/" mat-stroked-button color="primary">Voltar para a tela inicial</a>
          </div>
        </div>
      </div>
    </main>
  </div>

  <pme-footer></pme-footer>
</div>
